export class CustomerFinancialInfoController {

    constructor($scope) {
        this.$scope = $scope;
    }

    $onInit() {
        this.$scope.selectedContact = this.customer;
    }

}

export const CUSTOMER_FINANCIAL_INFO_CONTROLLER = ['$scope', CustomerFinancialInfoController];